import { createPinia as n } from "pinia";
import { AcsStandardLibraryI18nPlugin as o } from "../i18n/acs-standard-library-i18n-plugin.js";
import { ErrorLoggerPlugin as s } from "../error-logger/error-logger-plugin.js";
import { ThemePlugin as r } from "../themes/theme-plugin.js";
import { ToastPlugin as l } from "../toast-notification/plugin/toast-plugin.js";
class h {
  /**
   * The plugin options.
   */
  _Options;
  /**
   * Constructor
   *
   * @param options The plugin options.
   */
  constructor(i) {
    this._Options = i;
  }
  /**
   * Install the plugin to the app.
   *
   * @param app The app to install to.
   * @returns An object containing values that are created for injection, in case a consuming plugin needs to pass those on to other places.
   */
  install(i) {
    this._Options?.includePinia !== !1 && n().install(i);
    const t = new s().install(i);
    return new o(
      this._Options?.additionalI18nModules
    ).install(i), this._Options?.theme !== void 0 && new r(this._Options.theme).install(i), this._Options?.toastNotifications !== void 0 && new l(this._Options.toastNotifications).install(i), { errorLogger: t };
  }
}
export {
  h as AcsStandardLibraryBundledPlugin
};
//# sourceMappingURL=acs-standard-library-bundled-plugin.js.map
